<!--
 * @Author: ghy
 * @Date: 2023-07-18 13:56:30
 * @LastEditors: ghy
 * @LastEditTime: 2023-10-08 13:45:50
 * @Description: 
-->
<template>
  <div class="home-page">
    <div class="home-page-top">
      <div class="top-left">
        <div
          v-for="(item, index) in topTextList"
          :key="index"
          :style="{
            backgroundImage: 'url(' + item.bg + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }"
          @click="toPath(item.routerPath,item.tag)"
        >
          <img :src="item.icon" alt="" />
          <span>{{ item.text }}</span>
        </div>
      </div>
      <div class="top-right">
        <div @click="toLogin">系统登录入口</div>
        <span @click="toSystemList">系统介绍及帮助</span>
      </div>
    </div>
    <div class="home-carousel">
      <div class="carousel-top">{{ customName }}</div>
      <!-- <el-carousel :interval="3000" type="card" height="220px">
        <el-carousel-item v-for="item in imgBlobBox" :key="item">
          <img :src="item" alt="" />
        </el-carousel-item>
      </el-carousel> -->
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in imgBlobBox" :key="item + index">
          <img :src="item" @click="imgToBig(item)" style="cursor: pointer;"/>
          <!-- <el-image :src="item" :preview-src-list="imgBlobBox"> </el-image> -->
        </swiper-slide>
      </swiper>
      <el-dialog :visible.sync="imgVisible" width="70%" top="0">
        <img width="100%" height="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <div class="home-page-bot">
      <div class="bot-item">
        <div class="bot-item-head"><span>数据统计</span></div>
        <div class="pageViews">
          <div>
            <span>总访问量</span>
            <span>{{ gwstatObj.vistorTotal }}</span>
          </div>
          <div>
            <span>年访问量</span>
            <span>{{ gwstatObj.vistorYear }}</span>
          </div>
          <div>
            <span>今日访问量</span>
            <span>{{ gwstatObj.vistorDay }}</span>
          </div>
          <div>
            <span>系统用户数</span>
            <span>{{ gwstatObj.userNum }}</span>
          </div>
        </div>
      </div>
      <div class="bot-item">
        <div class="bot-item-head">
          <span>通知公告</span>
          <span style="color: #c9c9c9; cursor: pointer" @click="toNoticeList"
            ><span>更多</span><i class="el-icon-d-arrow-right"></i
          ></span>
        </div>
        <ul>
          <li v-for="(item, index) in noticeList" :key="index" @click="toDetails(item)" style="cursor: pointer;">
            <div>
              <span></span>
              <span
                class="spanCss"
                v-if="item.tags != null && item.tags == 2"
                >重要</span
              >
              <span
                class="spanCss"
                v-if="item.isExpired === 0"
                >最新</span
              >
              <span class="spanText" :style="{ 'max-width': item.tags != null && item.tags == 2 ? 'calc(475px - 36px)' : '475px' }">
               {{ item.noticeTitle }}
              </span>
            </div>
            <div>{{ parseTime(item.addTime) }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findGwStatDetail,
  findTopNoticeList,
  findActivedCustomDetail,
} from "@/api/homePage.js";
import { downloadAttachFile,getGwUrlSxyj, getGwUrlJspx,gwUrlbxtj ,getFileContentCache } from "@/api/common.js";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "home-page",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      topTextList: [
        {
          text: "通知公告",
          bg: require("../assets/indexbg1.png"),
          icon: require("../assets/indexicon1.png"),
          routerPath: "/noticeList",
        },
        {
          text: "案例展示",
          bg: require("../assets/indexbg2.png"),
          icon: require("../assets/indexicon2.png"),
          routerPath: "/caseList",
        },
        {
          text: "仪器样例",
          bg: require("../assets/indexbg3.png"),
          icon: require("../assets/indexicon3.png"),
          routerPath: "/equipList",
        },
        {
          text: "政策文件",
          bg: require("../assets/indexbg4.png"),
          icon: require("../assets/indexicon4.png"),
          routerPath: "/policyList",
        },
        {
          text: "书香燕京",
          bg: require("../assets/indexbg5.png"),
          icon: require("../assets/indexicon5.png"),
          tag:'sxyj'
        },
        {
          text: "教师培训",
          bg: require("../assets/indexbg6.png"),
          icon: require("../assets/indexicon6.png"),
          tag:'jspx'
        },
      ],

      gwstatObj: {},
      noticeList: [],
      imgIds: [],
      imgBlobBox: [],
      swiperOption: {
        // 衔接滑动
        loop: true,
        // 自动滑动
        autoplay: {
          delay: 2000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换。
          stopOnLastSlide: false,
          // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
          disableOnInteraction: false,
        },
        // 切换效果 "coverflow"（3d流）
        effect: "coverflow",
        // 设置slider容器能够同时显示的slides数量
        slidesPerView: 3,
        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
       // centeredSlides: true,
        // 设置为true则点击slide会过渡到这个slide。
        slideToClickedSlide: true,
        coverflowEffect: {
          // slide做3d旋转时Y轴的旋转角度
          rotate: 0,
          // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
          stretch: 0,
          // slide的位置深度。值越大z轴距离越远，看起来越小。
          depth: 60,
          // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
          modifier: 5,
          // 是否开启slide阴影
          slideShadows: true,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      dialogImageUrl: "",
      imgVisible: false,
      customName:"",
      gwUrlbxtjgwUrl: '',
    };
  },
  mounted() {
    this.gwUrlbxtj();
    this.findGwStatDetail();
    this.findTopNoticeList();
    this.findActivedCustomDetail();
  },
  methods: {
    toLogin() {
      window.open(this.gwUrlbxtjgwUrl, "3");
     // this.$router.push("/login");
    },
    async getGwUrlSxyj() {
      const res = await getGwUrlSxyj();
      window.open(res.data.gwUrl, "1");
    },
    async getGwUrlJspx() {
      const res = await getGwUrlJspx();
      window.open(res.data.gwUrl, "2");
    },
    async gwUrlbxtj(){
      const res = await gwUrlbxtj()
      this.gwUrlbxtjgwUrl = res.data.gwUrl; // 将res.data.gwUrl存储在this.gwUrl中
    },
    async findGwStatDetail() {
      const res = await findGwStatDetail();
      //console.log(res);
      this.gwstatObj = res.data.gwstat;
    },
    async findTopNoticeList() {
      const res = await findTopNoticeList();
      this.noticeList = res.data.listData;
    },
    async findActivedCustomDetail() {
      const res = await findActivedCustomDetail();
      this.customName = res.data.detail.customName
      this.imgIds = res.data.detail.images.map((v) => v.fileGuid);
      //console.log(this.imgIds);
      this.imgBlobBox = [];
      await Promise.all(this.imgIds.map((v) => this.getFileContentCache(v)));
    },
    async getFileContentCache(v) {
      const res = await getFileContentCache({
        fileGuid: v,
        moduleFlag: "custom",
      });
      const src =
        "data:image/png;base64," +
        btoa(
          new Uint8Array(res.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
        //console.log('Base64 Image:', src); // 打印单个图片的Base64
      this.imgBlobBox.push(src);
      //console.log('imgBlobBox:', this.imgBlobBox); // 打印整个图片数组
      //this.verifyImg = src;
    },
    imgToBig(item) {
      //console.log(111);
      //console.log('Clicked Image:', item); // 打印点击的图片Base64
      this.dialogImageUrl = item;
      this.imgVisible = true;
    },
    toSystemList(){
      this.$router.push('/systemList')
    },
    toPath(path,tag) {
      if(path){
        this.$router.push(path);
      }
      if(tag == 'sxyj'){
        this.getGwUrlSxyj()
      }else if(tag == 'jspx'){
        this.getGwUrlJspx()
      }
    },
    toNoticeList() {
      this.$router.push({ path: "/noticeList" });
    },
    toDetails(item){
      let routeData = this.$router.resolve({
        path: "/noticeDetails",
        query: {
          keyId: item.noticeId,
        },
      });
      window.open(routeData.href, '_blank')
    },
  },
};
</script>

<style lang="less" scoped>
.home-page {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  .home-page-top {
    display: flex;
    justify-content: space-between;
  }
}
.top-left {
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  > div {
    width: 258px;
    height: 128px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > img {
      width: 36px;
      height: 35px;
      object-fit: cover;
    }
    > span {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 21px;
      margin-top: 9px;
    }
  }
}
.top-right {
  width: 358px;
  height: 256px;
  flex-shrink: 0;
  background-image: url("../assets/loginBg.png");
  background-repeat: "no-repeat";
  background-size: "cover";
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  > div {
    font-size: 27px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 21px;
    margin-top: 100px;
    cursor: pointer;
  }
  > span {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-decoration: underline;
    color: #ffffff;
    line-height: 16px;
    margin-top: 62px;
    cursor: pointer;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.home-carousel {
  margin-bottom: 45px;
  position: relative;
  background: #fff;
  .swiper-pagination-bullets {
    position: absolute;
    width: 100% !important;
    background: #fff;
    padding-bottom: 10px;
  }
}
.swiper-button-prev,
.swiper-button-next {
  top: 58%;
  background: #bfbfbf;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  opacity: 0.25;
}
/deep/ .swiper-pagination-bullet {
  width: 30px !important;
  height: 5px;
  border-radius: 3px;
  margin-right: 18px;
}
/deep/ .swiper-pagination-bullet-active {
  background: #fac57f;
}
.carousel-top {
  margin-top: 12px;
  width: 100%;
  height: 62px;
  text-align: center;
  line-height: 62px;
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #cd0734;
}
.home-page-bot {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  .bot-item {
    height: 300px;
    background: #fff;
    .bot-item-head {
      width: 100%;
      height: 48px;
      padding: 0 23px;
      box-sizing: border-box;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #bd1a2d;
      line-height: 48px;
      border-bottom: 1px solid #bf282d;
      display: flex;
      justify-content: space-between;
    }
    > ul {
      padding: 10px 63px 25px 38px;
      box-sizing: border-box;
      > li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4px;
        > div:nth-child(1) {
          display: flex;
          align-items: center;
          > span {
            &:nth-child(1) {
              width: 4px;
              height: 4px;
              background: #333333;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
        }
        > div:nth-child(2) {
          font-size: 13px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #aeaeae;
          line-height: 21px;
          position: relative;
          left: 10px; /* 向右移动10px */
        }
      }
    }
  }
  .bot-item:first-child {
    width: 400px;
  }
  .bot-item:last-child {
    width: 725px;
  }
}
.spanCss {
  width: 36px;
  height: 20px;
  border: 1px solid #d9001b;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 13px;
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #d9001b;
  line-height: 21px;
}
.spanText {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  max-width: calc(100px - 36px); /* 限制最大宽度，你可以根据需要调整这个值 */
  text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
  overflow: hidden; /* 隐藏溢出的文本 */
  white-space: nowrap; /* 防止文本换行 */
}
.pageViews {
  display: flex;
  flex-wrap: wrap;
  > div {
    flex: 49%;
    height: 125px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > span:nth-child(1) {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #f59a23;
      line-height: 21px;
    }
    > span:nth-child(2) {
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      line-height: 21px;
      margin-top: 25px;
    }
  }
  div:nth-child(1) {
    border-right: 1px solid #d7d7d7;
    border-bottom: 1px solid #d7d7d7;
  }
  div:nth-child(2) {
    border-bottom: 1px solid #d7d7d7;
  }
  div:nth-child(3) {
    border-right: 1px solid #d7d7d7;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/homeHage.vue